import {
  CnpjFormField,
  FloatingFormItem,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import SelectGovernmentOperation from '@/components/_common/TaxReform/SelectGovernmentOperation';
import SelectGovernmentType from '@/components/_common/TaxReform/SelectGovernmentType';
import SelectOperationType from '@/components/_common/TaxReform/SelectOperationType';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import { Collapse, Row, Col, Select, Input } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';

interface Props {
  invoiceType: InvoiceType;
}

const InvoiceStepComplementInformation: React.FC<Props> = ({ invoiceType }) => {
  const intl = useIntl().formatMessage;

  return (
    <>
      <Collapse>
        <Collapse.Panel
          header="Informações complementares"
          key="complementInformation"
        >
          <Row gutter={[16, 16]}>
            {invoiceType === InvoiceType.NFS && (
              <>
                <Col span={24} md={12} lg={6}>
                  <FloatingFormItem
                    label={intl({ id: 'invoice.nfse.domain.simpleNational' })}
                    name="simpleNational"
                  >
                    <Select
                      allowClear
                      style={{ width: '100' }}
                      options={[
                        {
                          value: 'true',
                          label: intl({ id: 'invoice.domain.true' }),
                        },
                        {
                          value: 'false',
                          label: intl({ id: 'invoice.domain.false' }),
                        },
                      ]}
                    />
                  </FloatingFormItem>
                </Col>

                <Col span={24} md={12} lg={6}>
                  <FloatingFormItem
                    label={intl({
                      id: 'invoice.nfse.domain.culturalIncentive',
                    })}
                    name="culturalIncentivator"
                  >
                    <Select
                      allowClear
                      style={{ width: '100' }}
                      options={[
                        {
                          value: 'true',
                          label: intl({
                            id: 'invoice.domain.true',
                          }),
                        },
                        {
                          value: 'false',
                          label: intl({
                            id: 'invoice.domain.false',
                          }),
                        },
                      ]}
                    />
                  </FloatingFormItem>
                </Col>

                <Col xs={24} md={12}>
                  <FloatingFormItem
                    label="Código da cidade de incidência"
                    name="incidenceCityId"
                  >
                    <Input />
                  </FloatingFormItem>
                </Col>

                <Col xs={24} md={12} xl={6}>
                  <FloatingFormItem label="Código de tributação" name="taxCode">
                    <Input />
                  </FloatingFormItem>
                </Col>

                <Col xs={24} md={12} xl={6}>
                  <FloatingFormItem
                    label="Código do contribuinte"
                    name="taxpayerCode"
                  >
                    <Input maxLength={30} />
                  </FloatingFormItem>
                </Col>

                <Col span={24}>
                  <FloatingFormItem
                    name="description"
                    label={intl({
                      id: 'invoice.nfse.domain.additionalInformation',
                    })}
                  >
                    <Input.TextArea rows={4} />
                  </FloatingFormItem>
                </Col>
              </>
            )}

            {invoiceType !== InvoiceType.NFS && (
              <>
                <Col span={24} md={12} lg={8}>
                  <FloatingFormItem
                    label={intl({
                      id: 'invoice.domain.brokerIndicator',
                    })}
                    name="intermediaryIndication"
                  >
                    <Select
                      allowClear
                      style={{ width: '100' }}
                      options={[
                        {
                          value: 'true',
                          label: intl({
                            id: 'invoice.domain.true',
                          }),
                        },
                        {
                          value: 'false',
                          label: intl({
                            id: 'invoice.domain.false',
                          }),
                        },
                      ]}
                    />
                  </FloatingFormItem>
                </Col>

                <Col span={24} md={12} xl={8}>
                  <CnpjFormField
                    required={false}
                    fieldName="intermediaryCpfCnpj"
                    label={intl({
                      id: 'invoice.nfe.recipient.form.intermediaryCnpj',
                    })}
                  />
                </Col>

                <Col span={24} md={12} xl={8}>
                  <FloatingFormItem
                    label={intl({
                      id: 'invoice.nfe.recipient.form.SellerId',
                    })}
                    name="registrationIdentifier"
                  >
                    <Input />
                  </FloatingFormItem>
                </Col>
              </>
            )}

            <Col span={24} md={12} lg={8}>
              <FloatingFormItem
                name="deliveryPrevisionDate"
                label="Previsão de entrega"
              >
                <InputDate />
              </FloatingFormItem>
            </Col>

            {/* TODO: Será implementado pelo back posteriormente */}
            {/* <Col span={24} md={12} lg={8}>
              <FloatingFormItem
                name="occurrenceCityIbsCbs"
                label="Cód. do Município de consumo"
              >
                <Input />
              </FloatingFormItem>
            </Col> */}

            <Col span={24} md={12} lg={8}>
              <FloatingFormItem
                name="governmentType"
                label="Tipo governamental"
              >
                <SelectGovernmentType allowClear />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12} lg={8}>
              <FloatingFormItem
                name="governmentReducer"
                label="% de redução de alíq."
                extra="Relação a compra governamental"
              >
                <InputDecimal />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12} lg={8}>
              <FloatingFormItem
                name="governmentOperation"
                label="Tipo de operação governamental"
              >
                <SelectGovernmentOperation allowClear />
              </FloatingFormItem>
            </Col>

            {invoiceType === InvoiceType.NFS && (
              <>
                <Col span={24} md={12} lg={8}>
                  <FloatingFormItem
                    name="operationIndicatorCode"
                    label="Cód. Indicador de Operação"
                  >
                    <Input allowClear />
                  </FloatingFormItem>
                </Col>

                <Col span={24} md={12} lg={8}>
                  <FloatingFormItem
                    name="operationType"
                    label="Tipo de Operação"
                  >
                    <SelectOperationType allowClear />
                  </FloatingFormItem>
                </Col>
              </>
            )}
          </Row>
        </Collapse.Panel>
      </Collapse>
    </>
  );
};

export default InvoiceStepComplementInformation;
